/**
 * BAIS Lazy Load Admin JavaScript
 * 
 * JavaScript for the lazy load admin settings page
 */

jQuery(document).ready(function($) {
    'use strict';

    // Test lazy load functionality
    $('#test-lazy-load').on('click', function() {
        const button = $(this);
        const results = $('#lazy-load-test-results');
        
        button.prop('disabled', true).text('Testing...');
        results.html('<div class="testing">Running lazy load test...</div>');

        // Simulate test
        setTimeout(function() {
            const settings = {
                enabled: $('#coca_bais_lazy_load_enabled').is(':checked'),
                threshold: $('#coca_bais_lazy_load_threshold').val(),
                placeholder: $('#coca_bais_lazy_load_placeholder_type').val(),
                duration: $('#coca_bais_lazy_load_fade_duration').val(),
                strategy: $('#coca_bais_multiple_slider_strategy').val()
            };

            let html = '<div class="test-results">';
            html += '<h4>Test Results:</h4>';
            html += '<div class="result-item ' + (settings.enabled ? 'success' : 'warning') + '">';
            html += '<span class="dashicons ' + (settings.enabled ? 'dashicons-yes-alt' : 'dashicons-warning') + '"></span>';
            html += 'Lazy Loading: ' + (settings.enabled ? 'Enabled' : 'Disabled');
            html += '</div>';
            
            html += '<div class="result-item success">';
            html += '<span class="dashicons dashicons-yes-alt"></span>';
            html += 'Threshold: ' + settings.threshold;
            html += '</div>';
            
            html += '<div class="result-item success">';
            html += '<span class="dashicons dashicons-yes-alt"></span>';
            html += 'Placeholder: ' + settings.placeholder;
            html += '</div>';
            
            html += '<div class="result-item success">';
            html += '<span class="dashicons dashicons-yes-alt"></span>';
            html += 'Fade Duration: ' + settings.duration + 'ms';
            html += '</div>';
            
            html += '<div class="result-item success">';
            html += '<span class="dashicons dashicons-yes-alt"></span>';
            html += 'Strategy: ' + settings.strategy;
            html += '</div>';
            
            html += '</div>';

            results.html(html);
            button.prop('disabled', false).text('Test Lazy Load');
        }, 2000);
    });

    // Real-time preview updates
    const previewSettings = function() {
        const settings = {
            enabled: $('#coca_bais_lazy_load_enabled').is(':checked'),
            threshold: $('#coca_bais_lazy_load_threshold').val(),
            placeholder: $('#coca_bais_lazy_load_placeholder_type').val(),
            duration: parseInt($('#coca_bais_lazy_load_fade_duration').val()) || 300,
            strategy: $('#coca_bais_multiple_slider_strategy').val()
        };

        // Update preview info
        $('.preview-info').remove();
        if (settings.enabled) {
            const info = $('<div class="preview-info notice notice-info inline">' +
                '<p><strong>Lazy Load Preview:</strong> ' +
                'Threshold: ' + settings.threshold + ', ' +
                'Placeholder: ' + settings.placeholder + ', ' +
                'Duration: ' + settings.duration + 'ms, ' +
                'Strategy: ' + settings.strategy +
                '</p></div>');
            $('.coca-bais-preview-container').prepend(info);
        }
    };

    // Bind change events
    $('#coca_bais_lazy_load_enabled, #coca_bais_lazy_load_threshold, #coca_bais_lazy_load_placeholder_type, #coca_bais_lazy_load_fade_duration, #coca_bais_multiple_slider_strategy')
        .on('change', previewSettings);

    // Initial preview
    previewSettings();

    // Form validation
    $('form').on('submit', function() {
        const threshold = $('#coca_bais_lazy_load_threshold').val();
        const duration = parseInt($('#coca_bais_lazy_load_fade_duration').val());

        // Validate threshold format
        if (threshold && !/^(\d+)(px|%)?$/i.test(threshold.trim())) {
            alert('Please enter a valid threshold (e.g., "50px" or "10%")');
            return false;
        }

        // Validate duration range
        if (isNaN(duration) || duration < 0 || duration > 2000) {
            alert('Please enter a duration between 0 and 2000 milliseconds');
            return false;
        }

        return true;
    });

    // Settings tabs (if needed for future expansion)
    $('.nav-tab').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        
        $('.nav-tab').removeClass('nav-tab-active');
        $(this).addClass('nav-tab-active');
        
        $('.tab-content').hide();
        $(target).show();
    });

    // Help tooltips
    $('.help-tip').each(function() {
        const tip = $(this);
        tip.on('mouseenter', function() {
            const tooltip = $('<div class="tooltip">' + tip.data('tip') + '</div>');
            $('body').append(tooltip);
            
            const offset = tip.offset();
            tooltip.css({
                top: offset.top - tooltip.outerHeight() - 5,
                left: offset.left + (tip.outerWidth() / 2) - (tooltip.outerWidth() / 2)
            }).fadeIn(200);
        }).on('mouseleave', function() {
            $('.tooltip').fadeOut(200, function() {
                $(this).remove();
            });
        });
    });
});